import { Carousel, Container } from 'react-bootstrap';
import React, { useState, useEffect } from "react";

function PhotoGallery() {



  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Container className="d-flex justify-content-center">

      <Carousel activeIndex={index} onSelect={handleSelect} className="w-75">
       
          <Carousel.Item key="1" interval={3000}>
            <img src="/images/IMG_3572.JPG" alt='house' className="d-block w-100" />
          </Carousel.Item>
          <Carousel.Item key="2" interval={3000}>
            <img src="/images/IMG_3601.JPG" alt='house' className="d-block w-100" />
          </Carousel.Item>
          <Carousel.Item key="3" interval={3000}>
            <img src="/images/IMG_3606.JPG" alt='house' className="d-block w-100" />
          </Carousel.Item>
    
          <Carousel.Item key="4" interval={3000}>
            <img src="/images/IMG_3601.JPG" alt='house' className="d-block w-100" />
          </Carousel.Item>
      
          <Carousel.Item key="5" interval={3000}>
            <img src="/images/IMG_3615.JPG" alt='house' className="d-block w-100" />
          </Carousel.Item>
      
          <Carousel.Item key="6" interval={3000}>
            <img src="/images/IMG_3614.JPG" alt='house' className="d-block w-100" />
          </Carousel.Item>
      
          <Carousel.Item key="7" interval={3000}>
            <img src="/images/IMG_3616.JPG" alt='house' className="d-block w-100" />
          </Carousel.Item>
      
      
      </Carousel>
     
  
    </Container >
  );
}

export default PhotoGallery;
